import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import StatsBento from "@/components/site/StatsBento";
import Services from "@/components/site/Services";
import Testimonials from "@/components/site/Testimonials";
import Funnel from "@/components/site/Funnel";
import About from "@/components/site/About";
import Footer from "@/components/site/Footer";

export default function Home() {
  return (
    <main className="bg-[#0a0a0a] text-white" data-testid="home-page">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <StatsBento />
      <Testimonials />
      <Funnel />
      <Footer />
    </main>
  );
}
